import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {snail, pen, remove} from '../../../../../../../assets/symbols/symbols/Symbols.css';
import * as css from './PriceButton.css';
import {useMenuButton} from '../useMenuButton';

interface PriceButtonProps {
    label: string;
    isSelected: boolean;
    onSelect: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    iconStart?: string;
}

function PriceButton({label, isSelected, onSelect, onEdit, onDelete, iconStart = snail}: PriceButtonProps) {
    const {t} = useTranslation('subscriptions');

    const menuOptions = useMemo(() => [
        {text: t('editPrice'), onClick: onEdit || (() => {}), icon: pen, dataCyName: 'edit'},
        {text: t('delete'), onClick: onDelete || (() => {}), icon: remove, dataCyName: 'delete'}
    ], [t, onEdit, onDelete]);

    const {menuIcon, menuList} = useMenuButton(menuOptions);

    return (
        <css.priceButtonWrapper>
            <Button
                variant="neutral"
                size="category"
                iconStart={<css.priceIcon icon={iconStart} />}
                iconEnd={menuIcon}
                onClick={onSelect}
                className={isSelected ? 'selected' : ''}
            >
                {label}
            </Button>
            {menuList}
        </css.priceButtonWrapper>
    );
}

export default PriceButton;

